import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  min-width: 480px;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  flex: 1;

  border-radius: 16px;
  border: 1px solid var(--alias-color-line-normal);
  background: var(--alias-color-background-normal-normal);
`;

export const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 13px;
  align-self: stretch;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const Divider = styled.div`
  height: 1px;
  align-self: stretch;
  width: 100%;
  background-color: var(--alias-color-line-normal);
`;

export const PlanDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const PlanDescriptionLabelContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

export const PlanContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  align-self: stretch;
`;
